/* LOVE LACE — story layer
   1. No-repetition rule: an automatic (fallback) editorial image never repeats
      an image already used as a main visual elsewhere on the page. Chosen
      images (customizer / product pick) are registered first; duplicate
      fallbacks switch to their next unused candidate before they load.
   2. "What are you looking for?" background crossfade on hover / focus.
   Tiny, dependency-free, safe to run more than once (theme editor). */
(function () {
  'use strict';
  var doc = document;

  function dedupe(scope) {
    var pics = Array.prototype.slice.call((scope || doc).querySelectorAll('[data-ll-img]'));
    if (!pics.length) return;
    var used = window.__llUsedImgs || (window.__llUsedImgs = {});
    if (!scope) used = window.__llUsedImgs = {};
    pics.forEach(function (p) { if (p.getAttribute('data-ll-pri') !== '3') used[p.getAttribute('data-ll-img')] = 1; });
    pics.forEach(function (p) {
      if (p.getAttribute('data-ll-pri') !== '3') return;
      var id = p.getAttribute('data-ll-img');
      if (!used[id]) { used[id] = 1; return; }
      var alts = (p.getAttribute('data-ll-alts') || '').split(',');
      for (var i = 0; i < alts.length; i++) {
        var parts = alts[i].split('|');
        if (parts.length < 3 || used[parts[0]]) continue;
        var img = p.querySelector('img');
        if (!img) return;
        img.removeAttribute('srcset');
        img.setAttribute('srcset', parts[1] + ' 800w, ' + parts[2] + ' 1600w');
        img.src = parts[2];
        p.setAttribute('data-ll-img', parts[0]);
        p.setAttribute('data-ll-swapped', id);
        used[parts[0]] = 1;
        return;
      }
    });
  }

  function discover(scope) {
    (scope || doc).querySelectorAll('[data-ll-discover]').forEach(function (sec) {
      if (sec.__ll) return; sec.__ll = true;
      var bgs = sec.querySelectorAll('[data-ll-discover-bg]');
      var links = sec.querySelectorAll('[data-ll-discover-link]');
      function show(i) {
        bgs.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-ll-discover-bg') === i); });
        links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-ll-discover-link') === i); });
      }
      links.forEach(function (l) {
        var i = l.getAttribute('data-ll-discover-link');
        l.addEventListener('mouseenter', function () { show(i); });
        l.addEventListener('focus', function () { show(i); });
      });
      /* touch / small screens: follow whichever link sits in the middle of the viewport */
      if ('IntersectionObserver' in window && window.matchMedia('(hover: none)').matches) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) show(e.target.getAttribute('data-ll-discover-link')); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        links.forEach(function (l) { io.observe(l); });
      }
    });
  }

  /* product cards: colour swatch previews the variant image */
  function swatches() {
    if (doc.__llSw) return; doc.__llSw = true;
    function show(btn) {
      var src = btn.getAttribute('data-ll-sw-img'); if (!src) return;
      var card = btn.closest('[data-ll-card]'); if (!card) return;
      var img = card.querySelector('.ll-card__img--1'); if (!img) return;
      if (!img.__orig) img.__orig = { src: img.src, srcset: img.getAttribute('srcset') };
      img.removeAttribute('srcset'); img.src = src;
      card.querySelectorAll('.ll-swatch').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
    }
    doc.addEventListener('mouseover', function (e) { var b = e.target.closest && e.target.closest('[data-ll-sw-img]'); if (b) show(b); });
    doc.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.ll-card .ll-swatch'); if (b) { e.preventDefault(); show(b); } });
  }

  function init(scope) { dedupe(scope); discover(scope); swatches(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.LoveLaceStory = { dedupe: dedupe };
})();
